import React from 'react';
import Image from '@stencil/image';

import styled from 'styled-components';
import RupeeIcon from '../../../../Icons/RupeeIcon';

const TrendingDestinationsUI = ({
  trendingCityList,
  text,
  clickHandler,
  homePageClicksGAHandler,
}) => {
  return (
    <ListRecentTrendWrapper>
      <ListRecentHeadText>{text}</ListRecentHeadText>
      <ListTrendInnerWrap>
        {trendingCityList.map(item => {
          const {img_processed = {}, asp = '', h_text = ''} = item;
          return (
            <React.Fragment key={item.lid}>
              <li
                onClick={() => {
                  clickHandler(item);
                  homePageClicksGAHandler(item.h_text);
                }}
              >
                <TrendingDateImg
                  src={img_processed['landscape']['jpg']['g'] || ''}
                  alt={img_processed['landscape']['jpg']['g'] || ''}
                />
                <PopularBigImageOverlayWrap>
                  <OverlayMainText>{h_text}</OverlayMainText>
                  {asp ? (
                    <OverlaySubText>
                      Starts at <RuppeIconList />
                      {asp}/night
                    </OverlaySubText>
                  ) : (
                    ''
                  )}
                </PopularBigImageOverlayWrap>
              </li>
            </React.Fragment>
          );
        })}
      </ListTrendInnerWrap>
    </ListRecentTrendWrapper>
  );
};

const ListRecentTrendWrapper = styled.div(
  props => `
    padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xlarge} 0;
  `,
);

const ListRecentHeadText = styled.span(
  props => `
    font-size: ${props.theme.font.custom(14)};
    color: ${props.theme.colors.downriver.dark};
  `,
);

const ListTrendInnerWrap = styled.ul(
  props => `
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: ${props.theme.spacing.base};
    li{
      width: 15.3rem;
      height:8rem;
      margin-bottom: ${props.theme.spacing.xlarge};
      position: relative;
    }
  `,
);

const TrendingDateImg = styled(Image)(
  props => `
    width: 100%;
    height: 100%;
    border-radius: ${props.theme.misc.borderRadius.base};
    object-fit: cover;
  `,
);

const PopularBigImageOverlayWrap = styled.div(
  props => `
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(${props.theme.colors.shadow.light}, ${props.theme.colors.shadow.dark});
        border-radius: ${props.theme.misc.borderRadius.base};
        flex-direction: column;
        justify-content: flex-end;
        display: flex;
        padding: ${props.theme.spacing.base};
    `,
);

const OverlayMainText = styled.p(
  props => `
        font-weight:bold;
        font-size: ${props.theme.font.custom(14)};
        color: ${props.theme.colors.goWhite.base};
    `,
);

const OverlaySubText = styled.p(
  props => `
      color: ${props.theme.colors.goWhite.base};
    `,
);

const RuppeIconList = styled(RupeeIcon)(
  props => `
    fill: ${props.theme.colors.goWhite.base};
    width: .7rem;
    height: .7rem;
  `,
);

export default TrendingDestinationsUI;
